import creativesManagerAgent from 'common/src/modules/creatives/copilot/agents/creativesManagerAgent/creativesManagerAgent';
import {CLStore} from 'common/src/redux/store';
import {copilot} from '@cl/shared';

function initializeCreativesAgents(store: CLStore) {
  copilot.registerAgent(creativesManagerAgent(store));
}

export default initializeCreativesAgents;
